import { render, staticRenderFns } from "./DeliveryAuto.vue?vue&type=template&id=62a74c47&scoped=true"
import script from "./DeliveryAuto.vue?vue&type=script&lang=js"
export * from "./DeliveryAuto.vue?vue&type=script&lang=js"
import style0 from "./DeliveryAuto.vue?vue&type=style&index=0&id=62a74c47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a74c47",
  null
  
)

export default component.exports